export class NotAllowedException extends Error {}
